import { FilePdfIcon, FileDocIcon, FileTxtIcon, FileExcelIcon } from 'sharedComponents/Icons';
import { parse } from 'url';

const FILE_TYPES = {
  PDF: 'application/pdf',
  DOC: 'application/msword',
  DOCX: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  TXT: 'text/plain',
  XLX: 'application/vnd.ms-excel',
  XLSX: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
};

const EXTENSION_TYPES = {
  PDF: 'pdf',
  DOC: 'doc',
  DOCX: 'docx',
  TXT: 'txt',
  XLX: 'xls',
  XLSX: 'xlsx',
};

export const getFileIconByType = (fileType = '') => {
  switch (fileType) {
    case FILE_TYPES.PDF:
      return FilePdfIcon;

    case FILE_TYPES.DOC:
    case FILE_TYPES.DOCX:
      return FileDocIcon;

    case FILE_TYPES.XLX:
    case FILE_TYPES.XLSX:
      return FileExcelIcon;

    case FILE_TYPES.TXT:
      return FileTxtIcon;

    default:
      return undefined;
  }
};

export const getFileExtension = (url = '') =>
  parse(url)
    .pathname?.split('.')
    ?.pop()
    .toLowerCase();

export const getFileIconByUrl = (fileUrl) => {
  const extension = getFileExtension(fileUrl);
  switch (extension) {
    case EXTENSION_TYPES.PDF:
      return FilePdfIcon;

    case EXTENSION_TYPES.DOC:
    case EXTENSION_TYPES.DOCX:
      return FileDocIcon;

    case EXTENSION_TYPES.XLX:
    case EXTENSION_TYPES.XLSX:
      return FileExcelIcon;

    case EXTENSION_TYPES.TXT:
      return FileTxtIcon;

    default:
      return undefined;
  }
};

export const getFileNameFromUrl = (url = '') => {
  const name = parse(url)
    .pathname?.split('/')
    ?.pop();
  return name && unescape(name);
};
